<template>
  <b-modal
    body-class="p-0"
    v-model="mainModalHandler"
    ref="question-modal"
    hide-header
    hide-footer
    centered
    no-stacking
  >
    <template>
      <div class="header p-3">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <h4 class="mb-0 text-uppercase modal-title">
              {{ $t('invoices.requestQuery.requestText') }}
            </h4>
          </div>
          <div class="text-right">
            <b-link class="text-secondary mr-2 h3" @click="hide()">
              <b-icon-x class="text-muted" />
            </b-link>
          </div>
        </div>
      </div>
    </template>
    <template>
      <div class="drip-form-container border-0">
        <form @submit.prevent="submitTicket" novalidate id="invoiceTicket">
          <div class="drip-form p-3">
            <b-row>
              <b-col :sm="12">
                <b-form-group
                  class="dc-group"
                  :class="{
                    'is-invalid': errors.has('subject'),
                    'is-empty': form.subject === '' || form.subject === null
                  }"
                >
                  <!-- Pass an 'id' with multiselect to make the focus method work -->
                  <label>
                    <span class="subject-title">{{
                      $t('invoices.requestQuery.modal.subject')
                    }}</span>
                  </label>
                  <b-input-group class="dc-input-group">
                    <multiselect
                      v-validate="'required'"
                      v-model="form.subject"
                      :options="invoice.freshdesk_questions"
                      name="subject"
                      :selectLabel="$t('multiselect.selectLabel')"
                      :deselectLabel="$t('multiselect.deSelectLabel')"
                      :selectedLabel="$t('multiselect.selectedLabel')"
                      :placeholder="
                        $t('invoices.requestQuery.modal.subjectPlaceholder')
                      "
                      exact
                    >
                      <span class="action-input" slot="caret"
                        ><b-icon-chevron-down
                      /></span>
                    </multiselect>
                  </b-input-group>
                  <span class="error">{{ errors.first('subject') }}</span>
                </b-form-group>
              </b-col>
              <b-col :sm="12">
                <b-form-group class="dc-group">
                  <label>
                    <span class="subject-title">{{
                      $t('invoices.requestQuery.modal.description')
                    }}</span>
                  </label>
                  <b-form-textarea
                    name="form.description"
                    type="text"
                    rows="4"
                    v-model="form.description"
                  >
                  </b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <div class="footer mr-2">
            <hr />
            <div class="text-right footer-section">
              <b-button
                size="sm"
                class="py-2 px-2 mr-2 mb-3 text-uppercase font-header footer-btn"
                variant="outline-secondary"
                @click="hide()"
              >
                {{ $t('buyers.modal.cancel') }}
              </b-button>
              <b-button
                size="sm"
                type="submit"
                class="py-2 px-2 mr-2 mb-3 text-uppercase font-header footer-btn"
                variant="secondary"
              >
                {{ $t('invoices.esign.nps.btnSubmit') }}
              </b-button>
            </div>
          </div>
        </form>
      </div>
    </template>
  </b-modal>
</template>
<script>
import Multiselect from 'vue-multiselect'
import freshdeskService from '@/services/freshdesk'
export default {
  props: ['invoice', 'modal'],
  data() {
    return {
      mainModalHandler: this.modal,
      form: {
        description: '',
        subject: ''
      }
    }
  },
  methods: {
    submitTicket() {
      this.$validator.validate().then((res) => {
        if (res) {
          let data = this.invoice
          freshdeskService
            .createInvoiceTicket(data, this.form.subject, this.form.description)
            .then((res) => {
              this.mainModalHandler = false
              this.$mpTrack('Create freshdesk ticket for invoice', {
                form: this.form
              })
              this.$emit('request-success-modal')
            })
            .catch((err) => {
              console.log(err)
            })
        }
      })
    },
    show() {
      this.$refs['question-modal'].show()
    },
    hide() {
      this.$refs['question-modal'].hide()
    }
  },
  components: {
    Multiselect
  }
}
</script>
<style lang="scss" scoped>
@import '../../../assets/scss/variables';
.modal-title {
  letter-spacing: 1px;
  font-family: $montserrat;
  color: $secondary;
  font-size: large;
}
.subject-title {
  font-family: $lato !important;
  color: $dc-input-color !important;
  letter-spacing: 1.31px !important;
}
.footer {
  background-color: $dc-actions-bg;
  .footer-btn {
    width: 5rem;
    font-family: $montserrat;
  }
}
</style>
